const ValidationMap = {
	email: {
		required: '필수 입력입니다.',
		maxLength: {
			value: 254,
			message: '올바른 이메일 형식을 입력해주세요.',
		},
		pattern: {
			value: /^(?!.*\.\.)(?!\.)(?!.*\.$)[a-zA-Z0-9._-]+@[a-zA-Z0-9-]+\.[a-zA-Z]{2,}$/,
			message: '올바른 이메일 형식을 입력해주세요.',
		},
	},
	phone: {
		required: '필수 입력입니다.',
		pattern: {
			value: /^\d+$/,
			message: '숫자만 입력할 수 있어요.',
		},
	},
	required: {
		required: '필수 입력입니다.',
	},
	optional: {}, // 선택 항목은 검증 없음
}

export default ValidationMap
